import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Logger } from 'src/latest/src/services';
import { esignPDF } from "src/redux/services/commonServices";
import { updateSignPadStatus } from "src/redux/actions/questionnaireActions";
import { setModalContent } from "src/redux/modules/modalEvent";
import "./SignPad.scss";
import { SignatureSpace } from "./SignatureSpace";
import { ConsentPDFViewer } from "./ConsentPDFViewer";

interface Props {
    choice: any;
    onSignature: any;
}

export const SignPad = ({ choice, onSignature }: Props) => {
    const dispatch = useDispatch();
    const metadata = choice.metadata;

    const signpadStatus = useSelector(
        (state: any) =>
            state?.questionnaireData?.currentConfig?.isSignpadVisible
    );

    const signPDF = async (base64code: any) => {
        try {
            const res = await esignPDF(metadata.doc_id, base64code);

            onSignature(metadata.doc_id, res);
            dispatch(updateSignPadStatus(!signpadStatus));
        } catch (e: any) {
            Logger.log(e.message);
        }
    };

    const showSignaturePad = () => {
        dispatch(
            setModalContent({
                title: "Draw your signature here",
                modalContent: (
                    <SignatureSpace
                        onSignature={(base64Data: any) => {
                            signPDF(base64Data);
                        }}
                    />
                ),
                className: "signature-pad-modal",
                onToggle: () => {
                    dispatch(updateSignPadStatus(!signpadStatus));
                },
            })
        );
    };

    useEffect(() => {
        if (signpadStatus && metadata.signed === "false") showSignaturePad();
    }, [signpadStatus]);

    return (
        <>
            <ConsentPDFViewer metadata={metadata} />
        </>
    );
};
